import {EventEmitter, Injectable, Output} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, Validators} from '@angular/forms';
import {ClrWizard} from '@clr/angular';
import {ImageSelectorComponent} from 'src/app/standalone/image-selector/image-selector.component';
import {ReportHttpService} from '../http/report.http';
import {DashboardStore} from '../stores/dashboardStore';
import {LandingpageStore} from '../stores/landingpage.store';
import {AttractionResponse} from '../types/attraction';
import {
  Constant,
  Maintenance,
  MaintenanceResponse
} from '../types/maintenance';
import {PartResponse} from '../types/part';
import {FindingReport, MeasureReport, ReportRequest, ReportResponse} from '../types/report';
import {Unit, UnitResponse} from '../types/unit';
import {requireTrueOrFalse} from '../validators/form.validators';
import {UtilsService} from './utils.service';
import {Router} from '@angular/router';
import {AttractionHttpService} from '../http/attraction.http';
import {EventHttpService} from '../http/event.http';
import {PartHttpService} from '../http/part.http';
import {UnitHttpService} from '../http/unit.http';
import {AttractionMaintenanceHttpService} from '../http/maintenance.http';
import {BehaviorSubject, forkJoin, Observable} from "rxjs";
import {PerformMaintenanceComponent} from "../../standalone/perform-maintenance/perform-maintenance.component";
import {TranslateService} from "@ngx-translate/core";


@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  public displayHeader: boolean = false;
  public displaySuccess: boolean = false;

  public attraction: AttractionResponse | undefined = undefined;
  public subUnits: UnitResponse[] = [];
  public avaliableUnits: Unit[] = [];
  public selectedUnits: Unit[] = [];
  public part: PartResponse | undefined = undefined;
  public units: UnitResponse[] = [];
  public maintenance: MaintenanceResponse | undefined = undefined;

  public currentAttraction: AttractionResponse | undefined = undefined;
  public currentUnit: UnitResponse | undefined = undefined;
  public currentPart: PartResponse | undefined = undefined;
  public currentMaintenance: Maintenance | undefined = undefined;

  private lockAttraction = false
  private lockUnit = false;
  private lockPart = false;

  // public attractionFound = new UntypedFormControl(false, [Validators.requiredTrue]);
  // public unitFound = new UntypedFormControl(false, [Validators.requiredTrue]);
  // public partFound = new UntypedFormControl(false, [Validators.requiredTrue]);
  // public detailsFound = new UntypedFormControl(false, [Validators.requiredTrue]);

  public comment = new UntypedFormControl('');
  public findings = new UntypedFormArray([]);
  public findingComments = new UntypedFormArray([])
  public showFindingComments: boolean[] = [];
  public findingsPictures = new UntypedFormArray([])
  public uploadValidArr: boolean[] = [];
  public measures = new UntypedFormArray([], []);
  public checkedForMeasures: boolean = false;
  public valid: boolean = true

  public wordmarks: { [key: string]: { Page: number, Ref: string } } = {};

  public nextMaintenance: MaintenanceResponse | undefined = undefined;
  public nextPart: PartResponse | undefined = undefined;
  public nextUnit: UnitResponse | undefined = undefined;

  public wizard: PerformMaintenanceComponent | undefined = undefined;
  public skipFindings: boolean = false;

  public newReports: BehaviorSubject<ReportResponse | undefined>;


  @Output() finished = new EventEmitter<ReportResponse>();

  private openPromise: Promise<boolean> | undefined;
  constructor(private landingpageStore: LandingpageStore,
    private utils: UtilsService,
    private reportService: ReportHttpService,
    private dashboardStore: DashboardStore,
    private router: Router,
    private attractionService: AttractionHttpService,
    public store: LandingpageStore,
    private maintenanceService: AttractionMaintenanceHttpService,
    private translate: TranslateService) {
    this.newReports = new BehaviorSubject<ReportResponse | undefined>(undefined)
  }

  /**
  Directly resolve a maintenance
   */
  public resolveMaintenance(attraction: AttractionResponse, units: UnitResponse[], maintenance: MaintenanceResponse, subunits: UnitResponse[] = []) {
    this.clear();
    this.maintenance = maintenance;
    this.units = units;
    this.subUnits = subunits;
    this.avaliableUnits = [maintenance.deadline.unit, ...subunits.map(u => u.unit)];
    this.attraction = attraction;
    this.lockAttraction = false;
    this.lockUnit = false;
    this.lockPart = false;
    this.skipFindings = false;

    let findings: FindingReport[] = maintenance.maintenance.findings.map((finding) => {
      return {
        finding_id: finding.id,
        comment: "",
        present: false,
      }
    })

    let measures: MeasureReport[] = maintenance.maintenance.measures.map((measure) => {
      return {
        measure_id: measure.id,
        required: false,
        performed: false,
      }
    })

    let reportReq: ReportRequest = {
      comment: "",
      detailed: false,
      findings: findings,
      measures: measures,
    };
    this.onComplete(false, reportReq);
  }

  selectUnit(unit: Unit) {
    if (this.selectedUnits.find(u => u.id === unit.id)) {
      if (this.selectedUnits.length === 1) {
        this.selectedUnits = [this.maintenance!.deadline.unit];
      } else {
        this.selectedUnits = this.selectedUnits.filter(u => u.id !== unit.id);
      }
    } else {
      this.selectedUnits.push(unit);
    }
  }

  isSelected(unit: Unit) {
    return this.selectedUnits.find(u => u.id === unit.id) !== undefined;
  }

  public doMultipleMaintenances(attraction: AttractionResponse, maintenances: MaintenanceResponse[], subunits: UnitResponse[] = []) {
    this.clear();
    this.subUnits = subunits;
    this.lockAttraction = false;
    this.lockUnit = false;
    this.lockPart = false;
    this.skipFindings = false;

    var reportRequest: Observable<ReportResponse>[] = [];

    maintenances.forEach((maintenance) => {
      let findings: FindingReport[] = maintenance.maintenance.findings.map((finding) => {
        return {
          finding_id: finding.id,
          comment: "",
          present: false,
        }
      })

      let measures: MeasureReport[] = maintenance.maintenance.measures.map((measure) => {
        return {
          measure_id: measure.id,
          required: false,
          performed: false,
        }
      })

      let reportReq: ReportRequest = {
        comment: "",
        detailed: false,
        findings: findings,
        measures: measures,
      };
      reportRequest.push( this.reportService.createReport(attraction.attraction.id, maintenance.deadline.unit_id, this.subUnits.map(u=>u.unit.id), maintenance.maintenance.id, reportReq))
    })

    forkJoin(reportRequest).subscribe((reports: ReportResponse[]) => {
      this.newReports.next(reports[0])
      this.displaySuccessMessage();
      this.wizard?.close();
    });
  }

  public failMaintenance(attraction: AttractionResponse, units: UnitResponse[], maintenance: MaintenanceResponse, subunits: UnitResponse[] = []) {
    this.clear();
    this.attraction = attraction;
    this.units = units;
    this.subUnits = subunits;
    this.avaliableUnits = [maintenance.deadline.unit, ...subunits.map(u => u.unit)];
    this.selectedUnits = [maintenance.deadline.unit];
    this.maintenance = maintenance;
    this.checkCurrent(true)
    this.wizard?.open('fail');
  }

  public openMaintenance(attraction: AttractionResponse, units: UnitResponse[], maintenance: MaintenanceResponse, subunits: UnitResponse[] = []) {
    this.clear();
    this.attraction = attraction;
    this.units = units;
    this.subUnits = subunits;
    this.avaliableUnits = [maintenance.deadline.unit, ...subunits.map(u => u.unit)];
    this.selectedUnits = [maintenance.deadline.unit];

    this.maintenance = maintenance;
    this.checkCurrent(false)
    this.wizard?.open();
  }


  public isSplit(): number | undefined {
    if (!this.maintenance?.maintenance?.triggers) {
      return undefined;
    }
    if (this.maintenance!.maintenance!.triggers.find(t => t.key === "1/12") !== undefined) {
        return 12;
    }
    if (this.maintenance?.maintenance?.triggers.find(t => t.key === "1/10") !== undefined) {
      return 10;
    }
    return undefined;
  }
  public getSplit(): string {
    if (!this.maintenance?.maintenance?.triggers) {
      return "?";
    }
    if (this.maintenance!.maintenance!.triggers.find(t => t.key === "1/12") !== undefined) {
      return (((this.maintenance?.deadline.success_count) % 12) + 1) + "/12"
    }
    if (this.maintenance?.maintenance?.triggers.find(t => t.key === "1/10") !== undefined) {
      return (((this.maintenance?.deadline.success_count)  % 10) + 1) + "/10"
    }
    return "?";
  }

  public checkSkip(wizard: ClrWizard) {
    if (this.findings.length === 0) {
      wizard.next();
      return;
    }
  }

  public getPartsDescription(maintenance: MaintenanceResponse | undefined, units: UnitResponse[] | Unit[]): string {
    if (!maintenance) {
      return ""
    }
    let mappedUnits: Unit[] = [];
    //  If UnitResponse map to Unit
    if (units.length > 0 && "unit" in units[0]) {
      mappedUnits = units.map((u) => (u as UnitResponse).unit) as Unit[];
    } else {
      mappedUnits = units as Unit[];
    }

    if (!mappedUnits || mappedUnits.length === 0) {
      units = [maintenance.deadline.unit];
      mappedUnits = [maintenance.deadline.unit];
    }

    let str = "";
    if (units.length === 1) {
      str += `${this.utils.getI18nString(mappedUnits[0].name, this.translate.currentLang)} → `
    } else if (units.length > 1 && units.length < 2) {
      str += `${this.utils.getI18nString(mappedUnits[0].name, this.translate.currentLang)} (${mappedUnits.map(unit => this.utils.getI18nString(unit.name, this.translate.currentLang)).slice(1).join(", ")}) → `
    } else if (units.length > 3) {
      str += `${this.utils.getI18nString(mappedUnits[0].name, this.translate.currentLang)} (${mappedUnits.map(unit => this.utils.getI18nString(unit.name, this.translate.currentLang)).slice(1,3).join(", ")}, ...) → `
    }

    if (!maintenance.maintenance.parts || maintenance.maintenance.parts.length === 0) {
      str += this.translate.instant("Grid.Maintenance.NoAssembly")
    } else if (maintenance.maintenance.parts.length === 1) {
      str += this.utils.getI18nString(maintenance.maintenance.parts[0].description, this.translate.currentLang)
    } else {
      str += `(${maintenance.maintenance.parts.map(part => this.utils.getI18nString(part.description, this.translate.currentLang)).join(", ")})`
    }
    return str
  }

  public getMaintenanceDescription(maintenace: MaintenanceResponse | undefined): string {
    if (!maintenace) {
      return ""
    }
    const part = maintenace.maintenance.parts
    const unit = maintenace.maintenance.unit
    let str = "";

    str += `${maintenace.maintenance.test_piece}`;
    return str
  }

  public checkCurrent(fail?: boolean) {
    this.checkedForMeasures = false;
    if (this.maintenance && this.maintenance?.maintenance.findings) {
      this.findings = new UntypedFormArray(
        this.maintenance?.maintenance.findings.map((f) => new UntypedFormControl(undefined)), [requireTrueOrFalse()]
      );
      this.findingComments = new UntypedFormArray(
        this.maintenance?.maintenance.findings.map(() => new UntypedFormControl(''))
      )
      this.showFindingComments = this.maintenance?.maintenance.findings.map(() => false)
      this.uploadValidArr = this.maintenance?.maintenance.findings.map(() => true)
    }
    if (fail) {
      this.findings.controls.forEach((c) => {
        c.setValue(false);
      });
      this.getMeasures();
    }
    this.findings.valueChanges.subscribe(() => {
      this.getMeasures();
    })
  }

  public reset() {
    this.findings = new UntypedFormArray([]);
    this.findingComments = new UntypedFormArray([])
    this.showFindingComments = [];

    this.findingsPictures = new UntypedFormArray([])
    this.uploadValidArr = [];
    this.measures = new UntypedFormArray([], []);
    this.valid = true;
    this.skipFindings = false;
  }

  public clear() {
    this.reset()
    this.attraction = undefined;
    this.subUnits = [];
    this.units = [];
    this.selectedUnits = [];
    this.part = undefined;
    this.skipFindings = false;
    this.maintenance = undefined;
    this.displayHeader = false;
  }

  getMeasures() {
    let measuresRequired = false;
    if (this.findings.length === 0) {
      measuresRequired = true;
    }
    this.findings.controls.forEach((c) => {
      if (!c.value) {
        measuresRequired = true;
      }
    });

    if (measuresRequired && this.maintenance?.maintenance?.measures) {
      this.measures = new UntypedFormArray(
        this.maintenance.maintenance?.measures.map((f) => new UntypedFormControl(undefined)),
        [requireTrueOrFalse()]
      );
    } else {
      this.measures = new UntypedFormArray([], [requireTrueOrFalse()]);
    }
    this.checkedForMeasures = true;
  }
  onComplete(next: boolean, reportReq?: ReportRequest) {
    if (this.maintenance && this.attraction) {
      if (reportReq === undefined) {
        let measuresRequired = false;
        if (this.findings.length === 0) {
          measuresRequired = true;
        }
        this.findings.controls.forEach((c) => {
          if (!c.value) {
            measuresRequired = true;
          }
        });
        let findings: FindingReport[] = this.findings.controls.map((control, index) => {
          return {
            finding_id: this.maintenance!.maintenance.findings[index].id,
            comment: this.findingComments.controls[index].value,
            present: !control.value,
          }
        })
        let measures: MeasureReport[] = this.measures.controls.map((control, index) => {
          return {
            measure_id: this.maintenance!.maintenance.measures[index].id,
            required: measuresRequired,
            performed: control.value,
          }
        })

        reportReq = {
          comment: this.comment.value,
          detailed: this.skipFindings,
          findings: findings,
          measures: measures,
        };
      }
      this.reportService
        .createReport(this.attraction.attraction.id, this.maintenance.deadline.unit_id, this.subUnits.map(u=>u.unit.id), this.maintenance.maintenance.id, reportReq)
        .subscribe((report) => {
          this.newReports.next(report)
          this.displaySuccessMessage();
          this.wizard?.close();
        });
    }
  }

  newEvent() {
    this.newReports.next({} as ReportResponse);
  }

  displaySuccessMessage() {
    this.displaySuccess = true;
    setTimeout(() => {
      this.displaySuccess = false;
    }, 5000)
  }

  onUpload(imageSelectors: ImageSelectorComponent[], id: string) {
    return new Promise<boolean>((resolve, reject) => {
      let uploadPromises: Promise<void>[] = []
      imageSelectors.forEach((imageSelector) => {
        const uploadPromise = imageSelector.onUpload()
        uploadPromises.push(uploadPromise)
      })
      Promise.all(uploadPromises).then((values) => {
        resolve(true)
      })
    })
  }
}
